import { tokenAboutToExpire } from "@/utils/jwt";
import { OAPI_API_TYPE } from "@appetize/iw-common/constants";

let store = {};
let router = {};
const _interceptors = {
  request: {
    onSuccess: async config => {
      const APIType = store.getters["venueSettings/APIType"];
      const venueID = store.getters["venue/getActiveVenue"];
      config.headers["X-API-TYPE"] = APIType;

      if (APIType === OAPI_API_TYPE) {
        config.headers["Venue-ID"] = venueID;
      }

      if (config.headerType) {
        config.headers[config.headerType] = config.headerValue;
      }

      if (config.applyRefreshToken) {
        const iwRefreshToken = store.getters["common/getRefreshToken"];
        config.headers["Authorization"] = `Bearer ${iwRefreshToken}`;
      }

      if (config.applyToken) {
        const iwToken = store.getters["common/getIwToken"];
        if (!iwToken) return config;
        if (tokenAboutToExpire(iwToken)) {
          const token = await store.dispatch("common/refreshIWToken");
          if (!token) {
            if (store.getters["user/getUserData"]) {
              await store.dispatch("user/logOutUser", null, { root: true });
              window.location.replace(`${window.location.origin}/${venueID}`);
              return config;
            }
            await store.dispatch("common/authenticate", store.getters["venue/getActiveVenue"]);
            if (store.getters["user/getGuestUserData"]) {
              await store.dispatch("user/loginGuestUser", "", { root: true });
            }
            const newIwToken = store.getters["common/getIwToken"];
            config.headers["Authorization"] = `Bearer ${newIwToken}`;
            return config;
          }
          config.headers["Authorization"] = `Bearer ${token}`;
          return config;
        }
        config.headers["Authorization"] = `Bearer ${iwToken}`;
      }
      return config;
    },
    onReject: error => {
      return Promise.reject(error);
    }
  },
  response: {
    onSuccess: response => {
      return response;
    },
    onReject: error => {
      return Promise.reject(error);
    }
  }
};

export default {
  wrapAxios(axiosInstance) {
    axiosInstance.interceptors.request.use(_interceptors.request.onSuccess, _interceptors.request.onReject);
    axiosInstance.interceptors.response.use(_interceptors.response.onSuccess, _interceptors.response.onReject);
  },
  wrapStore(storeInstance) {
    store = storeInstance;
  },
  wrapRouter(routerInstance) {
    router = routerInstance;
  }
};
